/*!
 * Best4Home — Marble Paint Blog v2
 * - Before/after showcase drag slider (pointer + keyboard)
 * - FAQ accordion (single-open)
 * - Reading progress side bar (rAF-throttled)
 * - Products carousel: delegated to the theme's native <theme-scroll>
 *   web component (same DOM as featured-collection), so no JS needed here.
 * - Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  /* ── Before/after showcase slider ── */
  var showcases = document.querySelectorAll('.b4h-v2 .showcase');
  showcases.forEach(function (showcase) {
    var handle = showcase.querySelector('.showcase__handle');
    if (!handle) return;
    var EDGE_THRESHOLD = 4;

    var clamp = function (value, min, max) {
      return Math.min(max, Math.max(min, value));
    };

    var syncLabelVisibility = function (pct) {
      var hideBefore = pct <= EDGE_THRESHOLD;
      var hideAfter = pct >= (100 - EDGE_THRESHOLD);
      showcase.classList.toggle('is-edge-before', hideBefore);
      showcase.classList.toggle('is-edge-after', hideAfter);
    };

    var updateFromClientX = function (clientX) {
      var rect = showcase.getBoundingClientRect();
      if (!rect.width) return;
      var ratio = clamp((clientX - rect.left) / rect.width, 0, 1);
      var pct = Math.round(ratio * 1000) / 10;
      showcase.style.setProperty('--split-pos', pct + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
      syncLabelVisibility(pct);
    };

    var getCurrentPct = function () {
      var computed = getComputedStyle(showcase).getPropertyValue('--split-pos').trim();
      var value = parseFloat(computed);
      if (Number.isNaN(value)) return 50;
      return clamp(value, 0, 100);
    };

    var onPointerMove = function (event) {
      if (!showcase.classList.contains('is-dragging')) return;
      updateFromClientX(event.clientX);
    };

    var stopDrag = function () {
      showcase.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', stopDrag);
      window.removeEventListener('pointercancel', stopDrag);
    };

    handle.setAttribute('role', 'slider');
    handle.setAttribute('tabindex', '0');
    handle.setAttribute('aria-label', 'לפני ואחרי');
    handle.setAttribute('aria-valuemin', '0');
    handle.setAttribute('aria-valuemax', '100');
    handle.setAttribute('aria-valuenow', '50');

    handle.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      showcase.classList.add('is-dragging');
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', stopDrag);
      window.addEventListener('pointercancel', stopDrag);
      updateFromClientX(event.clientX);
    });

    showcase.addEventListener('pointerdown', function (event) {
      if (event.target.closest('.showcase__handle')) return;
      updateFromClientX(event.clientX);
    });

    handle.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      event.preventDefault();

      var next = getCurrentPct();
      if (key === 'Home') next = 0;
      if (key === 'End') next = 100;
      if (key === 'ArrowLeft') next = next - 5;
      if (key === 'ArrowRight') next = next + 5;

      next = clamp(next, 0, 100);
      showcase.style.setProperty('--split-pos', next + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(next)));
      syncLabelVisibility(next);
    });

    syncLabelVisibility(getCurrentPct());
  });

  /* ── FAQ accordion ── */
  var faqButtons = document.querySelectorAll('.b4h-v2 .faq__q');
  faqButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      faqButtons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  /* ── Reading progress (rAF-throttled) ── */
  var bar = document.querySelector('.b4h-v2 #progressBar');
  if (bar) {
    var ticking = false;
    var update = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      bar.style.height = Math.min(100, Math.max(0, pct)) + '%';
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
})();
